<template>
	<md-card>
		<md-card-area>
			<md-card-header>
				<div class="md-title">Change Password</div>
			</md-card-header>
	
			<md-card-content>
				<md-input-container md-has-password>
					<label>Old Password</label>
					<md-input required type="password" v-model="payload.oldPassword"></md-input>
				</md-input-container>
				<md-input-container md-has-password>
					<label>New Password</label>
					<md-input required type="password" v-model="payload.password" ref="password"></md-input>
				</md-input-container>
				<md-input-container md-has-password>
					<label>Confirm New Password</label>
					<md-input required type="password" v-model="payload.confirmPassword" ref="password"></md-input>
				</md-input-container>
			</md-card-content>
		</md-card-area>
		<md-card-actions>
			<md-button class="md-primary" @click="changePassword">Submit</md-button>
		</md-card-actions>
		<md-dialog-confirm ref="confirm_dailog" :md-title="userResponse.title" :md-content-html="userResponse.message" :md-ok-text="userResponse.okText" md-click-outside-to-close="true" @open="onOpen" @close="onClose">
		</md-dialog-confirm>
	</md-card>
</template>
<script>
import { makeRequest } from '../../../helper/internet';

export default {
	created() {

	},
	beforeMount() {
		this.$store.dispatch('setCurrentRoute', '/changePasssword');
	},
	mounted() {

	},
	beforeDestroy() {

	},
	destroyed() {

	},

	data() {
		return {
			payload: {
				password: '',
				oldPassword: '',
				confirmPassword: ''
			},
			userResponse: {
				title: 'Error!',
				message: 'Password fields cannot be empty.',
				okText: 'OK',
				cancelText: 'CANCEL'
			}
		}
	},
	components: {

	},
	computed: {

	},
	methods: {
		openDialog() {
			this.$refs.confirm_dailog.open();
		},
		closeDialog() {
			this.$refs.confirm_dailog.close();
		},
		onOpen() {

		},
		onClose(type) {

		},
		DeviceType() {
			return this.$store.getters.appDeviceType;
		},
		changePassword() {
			this.$store.dispatch('setIsProgressVisible', true);
			const { password, oldPassword, confirmPassword } = this.payload;
			if (password.length > 0 && oldPassword.length > 0 && confirmPassword.length > 0) {
				if (this.payload.password !== this.payload.confirmPassword) {
					this.$store.dispatch('setIsProgressVisible', false);
					this.userResponse.message = 'Confirm password does not match the new password.';
					this.openDialog();
					return
				}
				const value = { password, confirmPassword, oldPassword };
				makeRequest('/admin/changepassword', 'POST', null, value)
					.then((response) => {
						this.$store.dispatch('setIsProgressVisible', false);
						let { res, error } = response;
						if (!error && res.data) {
							if (res.data.message === 'success') {
								this.payload.password = '';
								this.payload.oldPassword = '';
								this.payload.confirmPassword = '';
								this.userResponse.title = 'Success';
								this.userResponse.message = 'Password changed successfully.';
								this.openDialog();
							}
							else if(res.data.message === 'wrong password'){
								this.userResponse.message = 'The old password is incorrect.';
								this.openDialog();
							}
							else {
								this.userResponse.message = 'Something went wrong! Please try again later.';
								this.openDialog();
							}
						}
						else {
							this.userResponse.message = 'Something went wrong! Please try again later.';
							this.openDialog();
						}
					})
					.catch((error) => {
						this.$store.dispatch('setIsProgressVisible', false);
						this.userResponse.message = 'Something went wrong! Please try again later.';
						this.openDialog();
					});
			}
			else {
				this.$store.dispatch('setIsProgressVisible', false);
				this.openDialog();
			}
		}
	}
}
</script>




// WEBPACK FOOTER //
// src/components/view/changePassword/ChangePassword.vue